import { AbstractControl, UntypedFormGroup, ValidatorFn } from "@angular/forms";
import { IDevice } from "src/app/shared/models/IDevice";
import { IDeviceType } from "src/app/shared/models/IDevice-type";

export class DeviceValidator {
    static ValidateDeviceID(devices: IDevice[], deviceTypes: IDeviceType[]): ValidatorFn {

        return (control: AbstractControl): { [key: string]: boolean } | null => {

            let controlValue = control.value as string;
            if (!controlValue || controlValue.trim() == '') {
                return null;
            }
            let controlId = (<UntypedFormGroup>control.parent).get('id')?.value as string;
            let controldeviceType = (<UntypedFormGroup>control.parent).get('deviceType')?.value as string;
            let existingDevice = devices.find(x => (x.deviceID.toLowerCase().trim() == controlValue.toLowerCase().trim()
                && x.deviceType.toLowerCase().trim() == controldeviceType.toLowerCase().trim()
                && (x.id.toString() != controlId)));

            let existingDeviceModel = deviceTypes.find(x => (x.name.toLowerCase().trim() == controldeviceType.toLowerCase().trim() &&
                new RegExp(x.regex).test(controlValue.trim())));

            return existingDevice ? { errorDeviceID: true } : !existingDeviceModel ? { errorDeviceModel: true } : null;
        };
    }
}